module.exports = __webpack_public_path__ + "static/img/slide2.ba0d59a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/appInstavice/slide2.jpg
// module id = KF5e
// module chunks = 1